import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showWarningMessage,
    showErrorMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
    showWarningMessage,
    showErrorMessage,
   API_URL,
};

export const GET_INSURANCE_TYPES_LIST_API = `${API_URL}/MasterInsuranceTypes/GetInsuranceTypes`;
export const POST_INSURANCE_TYPE_API = `${API_URL}/MasterInsuranceTypes/SaveInsuranceType`;
export const GET_INSURANCE_TYPE_DETAILS_API = `${API_URL}/MasterInsuranceTypes/GetInsuranceTypeById`;
export const DELETE_INSURANCE_TYPE_API = `${API_URL}/MasterInsuranceTypes/DeleteInsuranceType`;
export const InsuranceActionTypes = {
  get_insuranceTypesList: createRequestActionTypes('GET_INSURANCETYPESLIST'),
  post_insuranceType: createRequestActionTypes('POST_INSURANCETYPE'),
  get_insuranceTypeDetails: createRequestActionTypes('GET_INSURANCETYPEDETAILS'),
  delete_insuranceType: createRequestActionTypes('DELETE_INSURANCETYPE'),
};

export const MODULE = 'MASTER_INSURANCETYPE';





// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/constants/ApiConstants.js